import { render, staticRenderFns } from "./GameForum.vue?vue&type=template&id=22e9b35e&scoped=true&"
import script from "./GameForum.vue?vue&type=script&lang=js&"
export * from "./GameForum.vue?vue&type=script&lang=js&"
import style0 from "./GameForum.vue?vue&type=style&index=0&id=22e9b35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e9b35e",
  null
  
)

export default component.exports